<template>
  <div>
    <div v-if="surveyData">
      <div
        class="
            border-grey
            d-flex
            justify-content-between
            align-items-center
            pb-2
          "
      >
        <div class="d-flex">
          <back-arrow />
          <div class="d-flex flex-column">
            <h3 class="mb-1 header-title">
              {{ surveyData.surveyGroupName }}
            </h3>
            <div class="d-flex">
              <h5 class="header-description text-uppercase mb-0">
                {{ surveyData.year }}
                <span v-if="surveyData.quarter">
                  - R{{ surveyData.quarter[1] }}
                </span>
              </h5>
              <h5 class="header-description mb-0 ms-4">{{ responseRate }}</h5>
            </div>
          </div>
        </div>

        <h5
          class="compare-btn mb-0 cursor-pointer"
          @click="compareSurveys()"
        >
          <img
            src="@/assets/images/charts/compare.svg"
            alt="compare"
            class="img-fluid me-3"
            width="37"
          />
          Compare
        </h5>
      </div>
    </div>
    <div class="d-flex toggle-tabs g-0">
      <router-link
        v-for="link in links"
        :key="link.routeName"
        class="flex-grow-1 text-center anchor-tab"
        :to="{
          name: link.routeName,
          params: { id: $route.params.id, type: type },
        }"
        replace
      >
        {{ link.text }}
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "inner-survey-header",
  props: {
    links: {
      type: Array,
      require: true,
    },
    surveyData: {
      require: true,
    },
    type: {
      require: true,
    },
  },
  computed: {
    responseRate() {
      return `Response: ${this.surveyData.total}`;
    },
  },
  methods: {
    async compareSurveys() {
      try {
        await this.$store.dispatch("mainStats/loadSurveysOFAllYears", {
          surveyType: this.type.toLowerCase(),
        });
        this.$store.dispatch(
          "mainStats/showSelectSurveys",
          this.type.toLowerCase()
        );
      } catch (error) {
        this.$store.dispatch("dialog/showErrorDialog", {
          error: error,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.header-title {
  font-size: $font-size-32;
  font-weight: $font-weight-bold;
  line-height: $line-height-43;
}

.header-description {
  font-size: $font-size-24;
  font-weight: $font-weight-semiBold;
  line-height: $line-height-32;
}

.compare-btn {
  color: $color-white;

  img {
    width: 2.3125rem;
  }
}
.toggle-tabs {
  border-bottom: $border-grey-60;
}
</style>
